import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Menu from './Menu';
import Footer from './Footer';
import PageHeader from './PageHeader';

/**
 * NonPrivateRoute
 *
 * Extends react-router-dom.Route to include header and footer content.
 * If the user is not logged in, a simplified menu is provided
 */
const NonPrivateRoute = ({ component: Component, header, ...rest }) => {
  // There is no real security protection in a react app. Anything client side is insecure.
  // This is easily hacked but will still provide a good user experience.
  const isAuthenticated =
    window.sessionStorage.getItem('jwt') !== null &&
    window.sessionStorage.getItem('jwt').length > 0;

  const renderContent = () => (
    <React.Fragment>
      <Menu path={rest.path} isAuthenticated={isAuthenticated} />
      <PageHeader {...header} />
      <Route {...rest} component={Component} />
      <Footer />
    </React.Fragment>
  );

  return renderContent();
};

NonPrivateRoute.propTypes = {
  component: PropTypes.elementType,
  header: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  })
};

export default NonPrivateRoute;
